import type { GameComponentProps } from '../core/types';
import { FixtureGame } from '../fixture/FixtureGame';
import { MiniSudokuGame } from './MiniSudokuGame';

export function MiniSudokuEntry(props: GameComponentProps) {
  if (props.puzzle.generatorVersion < 2) return <FixtureGame {...props} />;
  return <MiniSudokuGame {...props} />;
}
